import api from "./index";

export async function updateRegionalPreferences({ userId, preferences }) {
    const res = await api.post(
        "/user/updateRegionalPreferences",
        {
            userid: String(userId),
            preferences,
        }
    );

    return res.data;
}